import { Component } from '@angular/core';

import {
  CamClickOrDoubleClickDirective,
  DndDirective,
  FileSizePipe,
  JoinPipe,
  LetDirective,
  OnRenderDirective,
  SafePipe,
  StopPropagationDirective,
} from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CamClickOrDoubleClickDirective,
        DndDirective,
        FileSizePipe,
        JoinPipe,
        LetDirective,
        OnRenderDirective,
        SafePipe,
        StopPropagationDirective,
        TestIdDirective,
    ],
    template: `
    <button camTestId="utils-stop-propagation" appStopPropagation>stop propagation</button>
    <div camTestId="utils-let" *ngLet="this.value as v">{{ v }}</div>
    <div camTestId="utils-on-render" camOnRender [onRender]="true">rendered</div>
    <button
      camTestId="utils-click-or-dblclick"
      camClickOrDoubleClick
      [clickHandler]="this.onClick"
      [dblClickHandler]="this.onDblClick"
    >
      click me
    </button>
    <div camTestId="utils-dnd" appDnd>drop zone</div>
    <div camTestId="utils-file-size">{{ 2048 | fileSize }}</div>
    <div camTestId="utils-join">{{ this.parts | join: ', ' }}</div>
    <div camTestId="utils-safe" [innerHTML]="'<b>safe html</b>' | safe: 'html'"></div>
  `
})
export class UtilsCase {
  public parts = ['a', 'b', 'c'];
  public value = 'let value';

  public onClick = (): void => void 0;
  public onDblClick = (): void => void 0;
}
